import React from 'react';
import { colors, fontSizes, fontWeights, radii, getStatusTone } from '../../theme/tokens';

const Tag = ({ variant = 'teal', status, style, children, ...rest }) => {
  let tone;
  if (variant === 'navy') tone = { bg: colors.mistStrong, fg: colors.navy };
  else if (variant === 'status') tone = getStatusTone(status);
  else tone = { bg: colors.tealTint, fg: colors.teal };
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 14px',
        borderRadius: radii.pill,
        background: tone.bg,
        color: tone.fg,
        fontSize: fontSizes.caption,
        fontWeight: fontWeights.semibold,
        lineHeight: 1.4,
        ...style,
      }}
      {...rest}
    >
      {children}
    </span>
  );
};

export default Tag;
